<template>
  <div>
    <input class="mb-2" placeholder="Digite o código ou nome do cliente..." v-model="searchText"/><button @click="search" class="btn-search">Buscar</button>
    <card title="Lista de Clientes" subTitle="Lista de todos os clientes cadastrados">
      <div slot="raw-content" class="table-responsive">
        <table class="table table-striped">
          <thead>
            <th>Código Cliente</th>
            <th>Nome</th>
            <th>CPF</th>
            <th>Email</th>
            <th>Ações</th>
          </thead>
          <tbody>
            <tr v-for="client in clients" :key="client.id">
              <td>{{ client.id }}</td>
              <td>{{ client.name }}</td>
              <td>{{ client.taxId }}</td>
              <td>{{ client.email || client.emailF }}</td>
              <td>
                <router-link :to="`clientes/${client.id}/visualizar`">
                  <p-button type="info" outline icon title="Visualizar Cliente">
                    <i class="fa fa-eye"></i>
                  </p-button>
                </router-link>
                <router-link :to="`clientes/${client.id}/cadastrar-ponto`">
                  <p-button class="" type="success" outline icon title="Cadastrar Ponto">
                    <i class="fa fa-plus"></i>
                  </p-button>
              </router-link>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </card>
    <Pagination
      :currentPage="pagination.currentPage"
      :totalPages="pagination.totalPages"
      v-on:update="updatePagination"
    />
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { mapActions } from "vuex";
import Pagination from "@/components/Pagination.vue";

export default {
  components: {
    Pagination
  },
  computed: {
    clients() {
      return this.$store.getters.clients;
    },
    pagination() {
      return this.$store.getters.clientsPagination;
    },
    searchType() {
      return /^\d+$/.test(this.searchText) ? 'id' : 'name';
    }
  },
  data() {
    return {
      searchText: '',
      currentPage: 1,
    };
  },
  methods: {
    ...mapActions(["fetchClients"]),
    async updatePagination({ currentPage }) {
      this.currentPage = currentPage;
      await this.fetchClients({ [this.searchType]: this.searchText, currentPage });
    },
    async search() {
      await this.fetchClients({ [this.searchType]: this.searchText, currentPage: this.currentPage });
    }
  },
  async mounted() {
    try {
      await this.fetchClients();
    } catch (err) {
      console.error(err);
      Swal.fire("Ops!", "Não foi possível carregar os clientes", "error");
    }
  }
};
</script>

<style scoped>
input {
  padding: 5px;
  width: 15rem;
}
button.btn-search {
  border: none;
  border: 1px solid;
  background: #9DCF6B;
  padding: 6px;
}
.btn-delete:disabled {
  cursor: not-allowed;
}
.btn-delete:hover:disabled {
  color: #dc3545;
}
</style>
